// extracted by mini-css-extract-plugin
export default {"disabled":"xriIWyfofipbVzF_SZ3j","placeHolderShimmer":"oFCCxawGTDo1MOVZ2RZA"};